import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Container from '../container'
import ArrowLink from '../arrow-link'
import styles from './cta.module.scss'
import shared from '../shared.module.scss'

const CTA = ({
  // CTA Props
  title,
  link,
  linkText,
  linkColor,
  linkNewTab,
  linkExternal,
  linkArrowType,
  linkArrowPosition,

  // Section Props
  className,
  marginBottom,
  containerFluid,
  textColor,
  backgroundColor,
}) => (
  <section
    className={ classNames( styles.cta, {
      [ shared.margin ]: marginBottom,
      [ styles.padding ]: backgroundColor
    }, className ) }
    style={{
      color: textColor,
      backgroundColor
    }}
  >
    <Container className={ styles.container } fluid={ containerFluid }>
      <p className={ styles.title }>{ title }</p>

      <ArrowLink
        to={ link }
        text={ linkText }
        color={ linkColor }
        newTab={ linkNewTab }
        external={ linkExternal }
        arrowType={ linkArrowType }
        arrowPosition={ linkArrowPosition }
        className={ styles.link }
      />
    </Container>
  </section>
)

CTA.propTypes = {
  // CTA Props
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkColor: PropTypes.string,
  linkText: PropTypes.string.isRequired,
  linkNewTab: PropTypes.bool,
  linkExternal: PropTypes.bool,
  linkArrowType: PropTypes.string,
  linkArrowPosition: PropTypes.string,

  // Section Props
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
  containerFluid: PropTypes.bool,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
}

CTA.defaultProps = {
  // CTA Props
  linkColor: '',
  linkNewTab: false,
  linkExternal: false,
  linkArrowType: 'arrow-circle',
  linkArrowPosition: 'start',

  // Section Props
  className: '',
  marginBottom: true,
  containerFluid: false,
  textColor: '',
  backgroundColor: '',
}

export default CTA